import { useCallback, useEffect, useState } from 'react';

import { useStorageToken } from '~lib/auth/use-storage-token';
import { loadEpflFolders, type EpflFolder } from '~lib/storage/epfl';

type Status = 'idle' | 'loading' | 'success' | 'error';

interface UseEpflFoldersResult {
  status: Status;
  folders: EpflFolder[];
  error: Error | null;
  refresh: () => void;
}

export function useEpflFolders(): UseEpflFoldersResult {
  const getToken = useStorageToken();
  const [status, setStatus] = useState<Status>('idle');
  const [folders, setFolders] = useState<EpflFolder[]>([]);
  const [error, setError] = useState<Error | null>(null);

  const run = useCallback(async () => {
    setStatus('loading');
    setError(null);
    try {
      const token = await getToken();
      const result = await loadEpflFolders(token);
      setFolders(result);
      setStatus('success');
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setStatus('error');
    }
  }, [getToken]);

  useEffect(() => {
    void run();
  }, [run]);

  return { status, folders, error, refresh: run };
}
